import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import gSteps from "@/components/g-steps/g-steps.vue"
import gDataTable from "@/components/g-data-table/g-data-table.vue"
import GerarNovoPedidoController from "@/shared/controllers/gerarNovoPedido/gerarNovoPedidoController";
import PedidoController from "@/shared/controllers/pedido/PedidoController"
import NovoPedidoViewModel from "@/shared/view-models/NovoPedidoViewModel"
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
// import ProdutoController from "@/shared/controllers/produto/produtoController"
import EVENTS from "@/shared/events/events";
import ClienteController from "@/shared/controllers/cliente/clienteController"


export default {
  name:'GerarNovoPedidoOrcamento',
  components:{
    'g-card': gCard,
    'g-form': gForm,
    'g-button': gButton,
    'g-steps': gSteps,
    'g-data-table': gDataTable,

  },
  setup(){
    return{
      v$: useVuelidate()
    }
  },
  validations(){
    return{
      novoPedidoViewModel: {
        MarkupRelacaoId:{
          required: helpers.withMessage("A Quantidade é obrigatória", required)
        },
        TipoPedido: {
          required: helpers.withMessage("O Tipo do Pedido é obrigatório", required)
        }
      }
    }
  },
  watch:{ 
    flagRepeticaoPedido(){
        if(this.flagRepeticaoPedido != false) {
          this.novoPedidoViewModel.PedidoSituacao = 1
          this.novoPedidoViewModel.TipoPedido = 0
        } 
        else {
          
          this.novoPedidoViewModel.TipoPedido = null
          this.TipoPedidoArray =  [
          {text: 'Pedido', value: 0, enum: 0},
          
          {text: 'Amostra / Lote Piloto', value: 1, enum: 1},
          
          {text: 'Pedido Prova / Iniciais', value: 2, enum: 2}
        ]
        }
    }
  },
  mounted(){
    this.popularGrid()
    var cartaId =  this.$route.params.id
    this.CartaPropostaId = cartaId
    this.TipoPedidoArray = PedidoController.GetInformacaoTipoPedidoEnum().TipoPedidoArray;
    this.PedidoSituacaoArray = PedidoController.GetInformacaoPedidoSituacaoEnum().PedidoSituacaoArray;
    // this.atualizaEmpresaRepresentante();

    this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.atualizaEmpresaRepresentante()
    }) 
  },

  data () {
    return {
        popup: false,
        submit: false,
        popupPrimeiroPedido : false,
        popupClienteTempoDeCompra : false,
        quantidadeArray: [],
        quantidadeSelecionada: {},
        CartaPropostaId: null,
        OrcamentoId: null,
        pedidoArray: [],
        TipoPedidoArray: [],
        opcoesRepeticao: false,
        flagRepeticaoPedido: false,
        PedidoSituacaoArray: [],
        dataOption: [
          {
            value: 0,
            name: 'Pedido',
          },
          {
            value: 1,
            name: 'Amostra / Lote Piloto',
            color: 'red'
          },
          {
            value: 2,
            name: 'Pedido Prova / Iniciais',
            color: 'red'
          }
        ],

        colunasTabelastep1 :[
          // {field: 'o', header: 'N° Solicitação'},
          {field: 'codigoExterno', header: 'N° Orçamento', width: '260px', ordena: true},
          {field: 'statusEnumTexto', header: 'Status', width: '260px', ordena: true},
          {field: 'nomeProduto', header: 'Nome Produto', width: '350px', ordena: true},
          {field: 'dataDigitacaoFormatada', header: 'Dt. Digitação', width: '130px', ordena: true, ordenacao: 'dataDigitacaoFormatada'},
          {field: 'dataVencimentoFormatada', header: 'Dt. Vencimento', width: '130px', ordena: true, ordenacao: 'dataVencimentoFormatada'},
          {field: 'dataValidadeFormatada', header: 'Dt. Retorno', width: '260px', ordena: true, ordenacao: 'dataValidadeFormatada'},
          {field: 'tipoFluxoOrcamentoEnumTexto', header: 'Fluxo', width: '260px', ordena: true},
        ],

        Filtro: {
          'codigoExterno': {value: null, matchMode: this.filtros.CONTAINS},
          'global': {value: null, matchMode: this.filtros.CONTAINS},
          'statusEnumTexto': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeProduto': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeFantasia': {value: null, matchMode: this.filtros.CONTAINS},
          'dataDigitacaoFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'dataValidadeFormatada': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeEmpresa': {value: null, matchMode: this.filtros.CONTAINS},
          'nomeRepresentante': {value: null, matchMode: this.filtros.CONTAINS},
        },
        OrcamentoArray : [],
        orcamentoId: '',
        novoPedidoViewModel: new NovoPedidoViewModel(),
        btnPedidoRepeticaoRA: null,
        produtoId: null,
        temOrcamentoSequencia: null
    }
  },

  methods: {
    // DesativaFlag(){
    //   this.flagRepeticaoPedido = false
    // },
    popularGrid(){
      this.$isLoading(true)
      let filtroNovoPedido = this.$store.state.filtroNovoPedido
      GerarNovoPedidoController.getOrcamentosFiltrados(filtroNovoPedido).requisicao
      .then(res => {
        this.OrcamentoArray = res.data.data || []
      }).finally(() => this.$isLoading(false))
    },

    getOrcamentosByProdutoId () {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Produto/GetProdutoByOrcamentoId/${this.novoPedidoViewModel.OrcamentoId}`,
      })
        .then((res) => {
          this.produtoId = res.data.data
        })
        .catch(() => {
      });
  },

    getPedidoRepeticao() {
      PedidoController.GetPedidoRepeticao(this.produtoId).requisicao
        .then((res) => {
          if (res.data.data !== null){
            this.novoPedidoViewModel.TipoPedido = res.data.data.tipoPedido
          }
        })
    },

    gerarNovoPedido() {
      PedidoController.gerarNovoPedido(this.novoPedidoViewModel).requisicao
      .then(res => {
        this.$isLoading(false)
        if(res.data.code == 200){
          this.$router.push(`gerar-novo-pedido/${res.data.data}/info-cliente-pedido`)
        }
      }).catch(() => this.$isLoading(false))
    },

    atualizaEmpresaRepresentante(){
      this.novoPedidoViewModel.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.novoPedidoViewModel.UnidadeId = this.$store.state.empresaSelecionadaId;
      // Atualiza o representante escolhido e realiza a busca novamente no grid
      this.$store.state.filtroNovoPedido.RepresentanteId = this.novoPedidoViewModel.RepresentanteId
      let filtroNovoPedido = this.$store.state.filtroNovoPedido
      GerarNovoPedidoController.getOrcamentosFiltrados(filtroNovoPedido).requisicao
      .then(res => {
        this.OrcamentoArray = res.data.data || []
      })
    },
//----------------------------------------------------------------------------------------
    verificaPedido(){},

    VoltarInicio(){
      this.$router.push(`/gerar-novo-pedido-inicio`)
    },

    fechaPopup(){
      this.popupCliente=false
    },

    editarClienteById(){
      ClienteController.EditarClienteById(this.$refs.tabela.retornaLinhasSelecionadas().clienteId).requisicao
    .then((response ) => {
      this.$store.state.cliente = response.data.data
      this.$store.commit('salvando');
      this.$router.push(`/ficha-cadastro`)
    
    })
    
    },

    redirecionaParaFicha(){
      this.editarClienteById()
    },

    fecharDialog(){
      this.popup=false
    },

    //verificar se o orçamento ta vencido
    abrirSelecaoQuantidade(){
      this.ValidadeOrcamentoSelecionado = this.$refs.tabela.retornaLinhasSelecionadas().dataVencimentoFormatada

      // Obter a data atual
      let dataAtual = new Date();
      dataAtual.setHours(0, 0, 0, 0); // Definir o horário para meia-noite

      // Converter a data fornecida em um objeto Date
      let partesData = this.ValidadeOrcamentoSelecionado.split("/");
      let dataFornecidaObjeto = new Date(partesData[2], partesData[1] - 1, partesData[0]);
      dataFornecidaObjeto.setHours(0, 0, 0, 0); // Definir o horário para meia-noite p n usar a hora na comparação

      // Comparar as datas
      if (dataFornecidaObjeto < dataAtual) {
          this.$toast.add({ severity: 'warn', summary: 'Não é possível continuar', detail: `Orçamento vencido em ${this.ValidadeOrcamentoSelecionado}`, life: 2000 });

      } else {
          this.abrirSelecaoQuantidadeOrcamentoCorreto();
      }
      
    },

//----------------------------------------------------------------------------------------
    abrirSelecaoQuantidadeOrcamentoCorreto(){

      /*eslint-disable*/
      // this.flagRepeticaoPedido = 1

      this.novoPedidoViewModel.TipoFluxoOrcamento = this.$refs.tabela.retornaLinhasSelecionadas().tipoFluxoOrcamento;

      if(this.novoPedidoViewModel.TipoFluxoOrcamento === 1)
      {
        this.bloquearEscolha = false
        this.novoPedidoViewModel.PedidoSituacao = 1
        this.TipoPedidoArray =  [
          {text: 'Pedido', value: 0, enum: 0},
          
          {text: 'Amostra / Lote Piloto', value: 1, enum: 1},
          
          {text: 'Pedido Prova / Iniciais', value: 2, enum: 2}
        ]
        this.novoPedidoViewModel.TipoPedido = 0
      }
      else{
        this.bloquearEscolha = true

        this.TipoPedidoArray =  [
          {text: 'Pedido', value: 0, enum: 0},
          
          {text: 'Amostra / Lote Piloto', value: 1, enum: 1},
          
          {text: 'Pedido Prova / Iniciais', value: 2, enum: 2}
        ]
        this.novoPedidoViewModel.TipoPedido = 0
      }

      
      this.$isLoading(true)
      this.novoPedidoViewModel.OrcamentoId = this.$refs.tabela.retornaLinhasSelecionadas().id;
      this.novoPedidoViewModel.TipoFluxoOrcamento = this.$refs.tabela.retornaLinhasSelecionadas().tipoFluxoOrcamento;
      this.novoPedidoViewModel.TipoPedido = 0
      this.novoPedidoViewModel.MarkupRelacaoId = null
      this.opcoesRepeticao = false

      if (this.novoPedidoViewModel.TipoFluxoOrcamento === 1) {
        this.opcoesRepeticao = true

      }      
      if(!this.novoPedidoViewModel.OrcamentoId){
        this.$toast.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione um orçamento antes de continuar', life: 2000 });
        this.$isLoading(false)
        return
      }
      this.getOrcamentosByProdutoId();   
      
      //this.verificaSeEhPrimeiroPedidoCliente()

      this.OrcamentoId = this.$refs.tabela.retornaLinhasSelecionadas().id;

      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetVerificaPrimeiroPedidoDoClienteByOrcamentoId/${this.OrcamentoId}`,
      })
        .then((response) => {
          this.$isLoading(false)
          if(response.data.data === true){
            this.popup = false;
            this.popupPrimeiroPedido = true;
          }else{
            this.popupPrimeiroPedido = false;

            this.verificaTempoDoUltimoPedidoGeradoCliente()



            
          }

          
        })




      // if(this.popupPrimeiroPedido === false){
      //   this.verificaTempoDoUltimoPedidoGeradoCliente()
      // }
      // if(this.popupClienteTempoDeCompra === false)
      // {
      //   GerarNovoPedidoController.getQuantidadesPedido(this.novoPedidoViewModel.OrcamentoId).requisicao
      //   .then(res => {
      //     this.$isLoading(false)
      //     this.arrayQuantidade = res.data.data;
      //     this.popup = true
      //   })      
      // }
    },

//----------------------------------------------------------------------------------------
    infoCliente(){
      if(this.v$.$invalid == true){
        this.submit = true
        this.v$.$silentErrors.forEach(error=>{
          this.$toast.add({severity:'error', summary: 'ERRO', detail:error.$message, life: 5000})
        })
        return
      }
      this.$isLoading(true)
      if (this.novoPedidoViewModel.MarkupRelacaoId === undefined){
        this.$toast.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione uma quantidade antes de continuar', life: 2000 });
        this.$isLoading(false)
        return
      }
      if (this.novoPedidoViewModel.TipoPedido === undefined){
        this.$toast.add({ severity: 'warn', summary: 'Atenção', detail: 'Selecione o tipo do pedido antes de continuar', life: 2000 });
        this.$isLoading(false)
        return
      }
      if(this.novoPedidoViewModel.TipoFluxoOrcamento === 0)
      {
        this.novoPedidoViewModel.PedidoSituacao = 0
      }

      this.$store.state.infosOrcamento = this.novoPedidoViewModel
      this.$store.commit('salvando');
      

      this.$isLoading(true)
      if (this.novoPedidoViewModel.PedidoSituacao === 2){
        PedidoController.VerificaPedidoByOrcamentoId(this.novoPedidoViewModel.OrcamentoId).requisicao
        .then(res => {
          let existePedido = res.data.data
          if (existePedido.length && existePedido) {
            this.$toast.add({ 
            severity: 'warn', 
            summary: 'Atenção', 
            detail: 'Existe pedido em andamento para este produto! Favor entrar em contato com a Análise antes de continuar a geração do pedido.', life: 2000 });
            this.$isLoading(false)
            return;
          } else {

            PedidoController.VerificaOrcamentoSequencia(this.novoPedidoViewModel.OrcamentoId).requisicao
              .then((res => {

                this.temOrcamentoSequencia = res.data.data

                if (this.temOrcamentoSequencia == true) {
                  PedidoController.UpdateOrcamentoSequenciaTemPedidosAnteriores(this.novoPedidoViewModel.OrcamentoId).requisicao
                  .then((res =>{

                      this.$router.push(`/resumo-sequencia/${this.novoPedidoViewModel.OrcamentoId}`);
                      this.$isLoading(false)
                  }))
                }
                else 
                  this.gerarNovoPedido()
              }))
            
          }
        })  
      } else {
        PedidoController.VerificaOrcamentoSequencia(this.novoPedidoViewModel.OrcamentoId).requisicao
              .then((res => {

                this.temOrcamentoSequencia = res.data.data
                if (this.temOrcamentoSequencia == true) {
                  
                  //TODO: CHAMAR AQUI VALIDACAO
                  PedidoController.UpdateOrcamentoSequenciaTemPedidosAnteriores(this.novoPedidoViewModel.OrcamentoId).requisicao
                  .then((res =>{
                    
                      this.$router.push(`/resumo-sequencia/${this.novoPedidoViewModel.OrcamentoId}`);
                      this.$isLoading(false)
                  }))

                }
                else 
                  this.gerarNovoPedido()
              }))
      }
    },

//----------------------------------------------------------------------------------------
    verificaSeEhPrimeiroPedidoCliente(){
      this.OrcamentoId = this.$refs.tabela.retornaLinhasSelecionadas().id;
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetVerificaPrimeiroPedidoDoClienteByOrcamentoId/${this.OrcamentoId}`,
      })
        .then((response) => {
          if(response.data.data === true){
            this.popup = false;
            this.popupPrimeiroPedido = true;
          }else{
            this.popupPrimeiroPedido = false;
          }



        })
        .catch(() => {
        });
    },

    verificaTempoDoUltimoPedidoGeradoCliente(){
      this.OrcamentoId = this.$refs.tabela.retornaLinhasSelecionadas().id;
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetUltimoPedidoClienteByOrcamentoId/${this.OrcamentoId}`,
      })
        .then((response) => {
          if(response.data.data === true){
            this.popupClienteTempoDeCompra = true;
          }else{
            this.popupClienteTempoDeCompra = false;

            GerarNovoPedidoController.getQuantidadesPedido(this.novoPedidoViewModel.OrcamentoId).requisicao
            .then(res => {
              this.$isLoading(false)
              this.arrayQuantidade = res.data.data;
              this.popup = true
            })   
          }

          
        })
        .catch(() => {
        });
    },

    alteraClienteSituacao(){
      this.redirecionaParaFicha()
      // this.ClienteId = this.$refs.tabela.retornaLinhasSelecionadas().clienteId;
      // this.axios({
      //   method: 'get',
      //   url: process.env.VUE_APP_WEB_API + `Pedido/AlteraClienteSituacaoParaFichaCadastral/${this.ClienteId}`,
      // })
      //   .then(() => {
      //   })
      //   .catch(() => {
      //   });
    },

    verificaPedidoDigitacao(){
      setTimeout(() => {
        this.OrcamentoArray.forEach(Element => { 
          if (Element.status == '12'){
            return true; 
          } else {
            return false; 
          }
      }, 1000);
    })
    }
//----------------------------------------------------------------------------------------
  },
};
